<ng-container *transloco="let t">
  <pxw-modal-dialog
    [title]="t('productHiddenDialog.title')"
    [acceptText]="t('productHiddenDialog.acceptText')"
    type="alert"
  >
    <pxw-icon icon="alert" />
    <ng-template #modalContent>
      <p>{{ t('productHiddenDialog.description') }}</p>
      <ul class="hidden-products">
        @for (hiddenProduct of hiddenProducts(); track hiddenProduct.presentationId ?? hiddenProduct.id) {
          <li>{{ hiddenProduct.name }}</li>
        }
      </ul>
    </ng-template>
  </pxw-modal-dialog>
</ng-container>
